module.exports = __webpack_public_path__ + "static/media/dafinite.d26fd8db.pdf";